<template>
  <div class="apply-induction">
    <template v-if="!initLoading">
      <my-form
        v-if="option.columns"
        ref="formRef"
        :data="data"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      >
        <template slot="formerProjectForm">
          <element-component
            v-model="data.formerProject"
            label="Former Project 转出项目"
            :option="{
              type: 'select',
              dictData: formerProjectList
            }"
          />
        </template>
        <template slot="newProjectForm">
          <element-component
            v-model="data.newProject"
            label="New Project 转入项目"
            :option="{
              type: 'select',
              dictData: newProjectList
            }"
          />
        </template>
        <template slot="expensePercentageForm">
          <element-component
            v-model="data.expensePercentage"
            label="Expense Percentage 转出项目费用比例"
            :disabled="true"
          />
        </template>
        <template slot="newExpensePercentageForm">
          <element-component
            v-model="data.newExpensePercentage"
            label="New Expense Percentage 转入项目费用比例"
            :option="{
              type: 'number',
              numberMax: Number(data.expensePercentage),
              numberMin: 0
            }"
          />
        </template>
      </my-form>
      <!-- submit and reset -->
      <b-row>
        <b-col
          cols="12"
          class="my-form_btns"
        >
          <p class="text-secondary">
            {{ explain }}
          </p>
          <b-button
            variant="primary"
            class="mr-3"
            :disabled="loading"
            @click="send"
          >
            {{ $t('_components.btns.send') }}
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="loading"
            @click="saveDrafts"
          >
            {{ $t('_components.btns.saveDrafts') }}
          </b-button>
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BFormGroup, BFormInput, BListGroupItem, BListGroup, BAvatar,
} from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue';
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import { templateFormat, templateSubmitFormat } from '@/util/func'
import website from '@/config/website';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import ElementComponent from '@/components/elementComponent.vue';
import { projects } from '@/api/staff/index';
import projectAPI from '@/api/base/project'
import { formatArray } from '@/components/components/utils'

export default {
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    ElementComponent,
  },
  props: {
    processKey: {
      type: String,
      default: undefined,
    },
    explain: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      formId: '35',
      loading: false,
      dialogShow: false,
      hasDept: false,
      data: {
        staffId: null,
        formerProject: null,
        newProject: null,
        expensePercentage: null,
        newExpensePercentage: 0,
      },
      formerProjectList: [],
      formerProjectAllList: [],
      newProjectAllList: [],
      columns: [],
      interviewUsers: [],
      initLoading: false,
    }
  },
  watch: {
    'data.staffId': {
      async handler(e) {
        const res = await projects.getList(1, -1, { staffId: e, status: 1 })
        const temp = res.data.data.records
        this.formerProjectAllList = temp
        this.formerProjectList = formatArray(temp, 'projectName', 'projectId')
      },
    },
    'data.formerProject': {
      handler(e) {
        if (e) {
          const find = this.formerProjectAllList.find(o => String(o.projectId) === String(e)) || {}
          this.data.expensePercentage = find.expensePercentage
        } else {
          this.data.expensePercentage = null
        }
      },
    },
  },
  async mounted() {
    this.onLoad(this.formId)

    const res = await projectAPI.getList(1, -1)
    const temp = res.data.data.records
    this.newProjectAllList = temp
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    companyId() {
      return this.userAllInfo.staffInfo.companyId || this.userAllInfo.workerInfo.companyId
    },
    option() {
      const columns = []
      const { deptId } = this.data
      this.columns.forEach(item => {
        const dictQuery = item.formOption.dictQuery || {}
        const temp = item
        if (item.formOption.dictCode === 'dept') {
          dictQuery.parentId = this.companyId
          this.hasDept = true
        }
        if (item.formOption.dictCode === 'post') {
          dictQuery.deptId = deptId
          temp.disabled = !deptId
          temp.formOption.small = this.$t('_components.placeholder.firstInput') + this.i18n('labelEmployment.deptId')
        }
        temp.formOption.dictQuery = dictQuery
        columns.push(temp)
      });
      const option = {
        columns,
      }
      console.log(option, this.data);
      return option || {}
    },
    newProjectList() {
      const map = this.formerProjectAllList.map(o => String(o.projectId))
      const arr = this.newProjectAllList.filter(o => map.indexOf(o.id) === -1)
      return formatArray(arr, 'projectName', 'id')
    },
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    onLoad(formId) {
      templateFormAPI.detail({ formId }).then(res => {
        const temp = res.data.data.records
        const result = []
        temp.forEach(item => {
          const t = item
          if (['photo', 'confirmFile', 'fileIds', 'latestPayslip', 'trainingCertificate', 'highestQualificationCert', 'nricFile'].indexOf(item.fieldName) !== -1) {
            t.fieldName = `${item.fieldName}Files`
          }
          result.push(t)
        })
        this.columns = templateFormat(result)// , setDictQuery)
      })
    },
    handleSubmit(form) {
      const params = templateSubmitFormat(form, this.columns)
      params.processKey = this.processKey
      params.formId = this.formId
      const router = website.staffProcessRouter

      if (this.hasDept) {
        params.companyId = this.companyId
      }
      if (this.isDrafts) {
        this.loading = true
        applyAPI.add(params, router[params.formId]).then(res => {
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.loading = false
        })
      } else {
        applyAPI.saveAndStart(params, router[params.formId]).then(res => {
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      }
    },
    send() {
      this.isDrafts = false
      this.$refs.formRef.validationForm()
    },
    saveDrafts() {
      this.isDrafts = true
      this.$refs.formRef.validationForm()
    },
  },
}

</script>

<style lang='scss' scoped>
.apply-induction{
  height: 100%;
  position: relative;
    .my-form{
      height: calc(100% - 72px);
      margin-bottom: 100px;
      position: relative;
      overflow: hidden;
      &_btns{
        left: 0;
        right: 0;
        position: absolute;
        bottom: 0;
        text-align: center;
        border-top: 1px solid #EBE9F1;
        background: #FFF;
        padding: 1.5rem 0;
      }
    }

}
</style>

<style lang="scss">
.modal-content{
  .interview-user-container{
    max-height: 200px;
    overflow: auto;
    .list-group-item{
      cursor: pointer;
    }
  }
}
</style>
